import mapboxgl from "mapbox-gl";
import { neighborsSources } from "./sources";
import { variableSymbolLayout } from "../../map/layers/layouts";
import { IconType } from "../../map/icons";
import {
    addLayersIfNotExist,
    safeRemoveLayers,
} from "../../map/layers/generics";
import { convertUTCtoJST } from "../../../utils/formatting";

export const neighborsGoNGLyr: mapboxgl.Layer = {
    id: "neighborsSourcesGoNGLyr",
    source: neighborsSources.neighborsGoNGSrc,
    type: "symbol",
    layout: variableSymbolLayout(IconType.SQUARE_RED),
};

export const neighborsGoOKLyr: mapboxgl.Layer = {
    id: "neighborsSourcesGoOKLyr",
    source: neighborsSources.neighborsGoOKSrc,
    type: "symbol",
    layout: variableSymbolLayout(IconType.SQUARE_ORANGE),
};

export const neighborsCruiseNGLyr: mapboxgl.Layer = {
    id: "neighborsSourcesCruiseNGLyr",
    source: neighborsSources.neighborsCruiseNGSrc,
    type: "symbol",
    layout: variableSymbolLayout(IconType.TRIANGLE_RED),
};

export const neighborsCruiseOKLyr: mapboxgl.Layer = {
    id: "neighborsSourcesCruiseOKLyr",
    source: neighborsSources.neighborsCruiseOKSrc,
    type: "symbol",
    layout: variableSymbolLayout(IconType.TRIANGLE_ORANGE),
};

export const addAllLayersInOrder = (map: mapboxgl.Map): void => {
    addLayersIfNotExist(map, [
        neighborsGoNGLyr,
        neighborsGoOKLyr,
        neighborsCruiseNGLyr,
        neighborsCruiseOKLyr,
    ]);
};

export const removeLayers = (map: mapboxgl.Map): void => {
    safeRemoveLayers(map, [
        neighborsGoNGLyr,
        neighborsGoOKLyr,
        neighborsCruiseNGLyr,
        neighborsCruiseOKLyr,
    ]);
};

const hoveredGoOK: any = null;
const hoveredGoNG: any = null;
const hoveredCruiseOK: any = null;
const hoveredCruiseNG: any = null;

export const setHighlightsWithPopup = (map: mapboxgl.Map): void => {
    setHighlightWithPopup(
        neighborsGoOKLyr.id,
        neighborsSources.neighborsGoOKSrc,
        map,
        hoveredGoOK,
        neighborsTemplate
    );

    setHighlightWithPopup(
        neighborsGoNGLyr.id,
        neighborsSources.neighborsGoNGSrc,
        map,
        hoveredGoNG,
        neighborsTemplate
    );

    setHighlightWithPopup(
        neighborsCruiseOKLyr.id,
        neighborsSources.neighborsCruiseOKSrc,
        map,
        hoveredCruiseOK,
        neighborsTemplate
    );

    setHighlightWithPopup(
        neighborsCruiseNGLyr.id,
        neighborsSources.neighborsCruiseNGSrc,
        map,
        hoveredCruiseNG,
        neighborsTemplate
    );
};

export const setHighlightWithPopup = (
    layerName: string,
    dataSourceName: string,
    map: mapboxgl.Map,
    hoveredItem: any,
    templateMaker: any
): void => {
    let popup;
    map.on("mouseenter", layerName, (e: any) => {
        map.getCanvas().style.cursor = "pointer";
        hoveredItem = e.features[0].id;

        if (hoveredItem) {
            map.setFeatureState(
                { source: dataSourceName, id: hoveredItem },
                { hover: false }
            );

            if (e.features && e.features[0] && e.features[0].properties) {
                popup = new mapboxgl.Popup()
                    .setLngLat(e.lngLat)
                    .setHTML(templateMaker(e.features[0]));
                popup.addTo(map);
            }
        }

        hoveredItem = e.features[0].id;

        (map as mapboxgl.Map).setFeatureState(
            { source: dataSourceName, id: hoveredItem },
            { hover: true }
        );
    });

    map.on("mouseleave", layerName, (e: any) => {
        if (hoveredItem) {
            map.setFeatureState(
                { source: dataSourceName, id: hoveredItem },
                { hover: false }
            );
        }
        map.getCanvas().style.cursor = "initial";
        hoveredItem = null;
        popup.remove();
    });
};

const convertCheckSpeedToLabel = (checkSpeed: string) => {
    switch (checkSpeed) {
        case "NG":
            return "速い";
        case "OK":
            return "妥当";
        default:
            return "";
    }
};

const convertBoardingTypeToLabel = (boardingType: string) => {
    switch (boardingType) {
        case "pick_up_go":
            return "GO";
        case "cruise":
            return "流し";
        default:
            return "";
    }
};

export const neighborsTemplate = (feature: any): string => {
    const neighborPickupEntryTime = feature.properties.neighborPickupEntryTime;
    const entryTime = feature.properties.entryTime;
    const checkSpeed = feature.properties.checkSpeed;
    const boardingType = feature.properties.neighborBoardingType;

    return `
                    <div>
                    <strong>
                    他車車両実車・受諾地
                    </strong>
                    </div>
                    <div>
                    他車実車・受諾時刻: ${convertUTCtoJST(
                        neighborPickupEntryTime
                    )}
                    </div>
                    <div>
                    通過時刻: ${convertUTCtoJST(entryTime)}
                    </div>
                    <div>
                    走行速度: ${convertCheckSpeedToLabel(checkSpeed)}
                    </div>
                    <div>
                    乗車種別: ${convertBoardingTypeToLabel(boardingType)}
                    </div>
                    `;
};
